import { SVGProps } from 'react';

const DeepSearchIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={15}
    fill="none"
    {...props}
  >
    <path
      fill="currentColor"
      d="M8.296.839a8 8 0 0 1 5.361 13.651.5.5 0 0 1-.707-.707A7.003 7.003 0 0 0 8.26 1.838l-.26-.005A7 7 0 0 0 2.87 13.596l.18.187.064.078a.5.5 0 0 1-.692.693l-.08-.064-.204-.214A8.002 8.002 0 0 1 .609 5.771 8 8 0 0 1 8 .833l.297.006Z"
    />
    <path
      fill="currentColor"
      d="M8.346 4.18a4.668 4.668 0 0 1 2.955 7.953.5.5 0 1 1-.707-.707 3.668 3.668 0 0 0-2.323-6.25l-.27-.009a3.67 3.67 0 0 0-3.597 4.382c.124.622.406 1.2.819 1.678l.184.199.065.079a.5.5 0 0 1-.693.692l-.079-.064-.234-.253A4.668 4.668 0 0 1 8 4.167l.345.013Z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M8 7.5a1.335 1.335 0 0 1 .943 2.276 1.335 1.335 0 0 1-2.276-.943A1.333 1.333 0 0 1 8 7.5Zm0 1a.334.334 0 1 0 0 .667.334.334 0 0 0 0-.667Z"
      clipRule="evenodd"
    />
  </svg>
);

export default DeepSearchIcon;
